/**
 * Static-translations for de. Generated from:
 *  - `online/lang/static-translations.ts` (legacy, via KEY_MAP)
 *  - `tools/sdk-translations.mjs` (SDK-specific strings)
 *
 * Do not edit by hand — changes are lost on the next `node tools/gen-locales.mjs`.
 * To fix a translation, edit legacy/sdk-translations.mjs and regenerate.
 */
const de = {
  'anon.description_default': 'Gast-Sitzung wird eingerichtet…',
  'anon.heading_default': 'Als Gast fortfahren',
  'anon.try_again': 'Erneut versuchen',
  'auth.back_to_login': 'Zurück zum Login',
  'auth.check_email_message': 'Sehen Sie in Ihren E-Mails nach einem Bestätigungscode.',
  'auth.check_email_title': 'Prüfen Sie Ihre E-Mails',
  'auth.confirm_email_subtitle': 'Geben Sie den Code ein, den wir an Ihre E-Mail gesendet haben, um die Registrierung abzuschließen.',
  'auth.confirm_email_title': 'Bestätigen Sie Ihre E-Mail',
  'auth.confirmation_code': 'Bestätigungscode',
  'auth.continue_with_apple': 'Weiter mit Apple',
  'auth.continue_with_facebook': 'Mit Facebook fortfahren',
  'auth.continue_with_github': 'Mit GitHub fortfahren',
  'auth.continue_with_google': 'Weiter mit Google',
  'auth.create_account': 'Konto erstellen',
  'auth.default_subtitle': 'Bitte melden Sie sich an, um alle Funktionen zu nutzen und Ihre Daten zu synchronisieren.',
  'auth.email': 'E-Mail-Adresse',
  'auth.email_already_registered': 'Diese E-Mail ist bereits registriert. Melden Sie sich unten mit Ihrem Passwort oder dem Konto an, mit dem Sie sich registriert haben.',
  'auth.email_exists': 'Ein Konto mit dieser E-Mail existiert bereits.',
  'auth.email_not_confirmed': 'Bitte bestätigen Sie zuerst Ihre E-Mail.',
  'auth.forgot_password': 'Passwort vergessen?',
  'auth.forgot_password_title': 'Passwort vergessen?',
  'auth.forgot_subtitle': 'Geben Sie Ihre E-Mail ein, wir senden Ihnen einen Link zum Zurücksetzen des Passworts.',
  'auth.generic_error': 'Etwas ist schiefgelaufen',
  'auth.have_account': 'Haben Sie ein Konto?',
  'auth.hide_password': 'Passwort verbergen',
  'auth.identity_already_linked': 'Dieses Konto ist bereits registriert. Melden Sie sich unten damit an.',
  'auth.invalid_credentials': 'Ungültige E-Mail oder Passwort',
  'auth.invalid_otp': 'Der Code ist ungültig oder abgelaufen.',
  'auth.last_used': 'Zuletzt genutzt · {email}',
  'auth.last_used_no_email': 'Zuletzt genutzt',
  'auth.link_purchase_subheading': 'Wir verknüpfen den Kauf mit Ihrem Konto, damit der Zugriff erhalten bleibt.',
  'auth.log_in': 'Anmelden',
  'auth.log_in_link': 'Anmelden',
  'auth.login_continue_purchase': 'Einloggen, um den Kauf fortzusetzen',
  'auth.network_error': 'Netzwerkfehler. Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
  'auth.new_password_optional': 'Neues Passwort (optional — nur für Passwort-Reset)',
  'auth.no_account': 'Kein Konto?',
  'auth.or': 'oder',
  'auth.password': 'Passwort',
  'auth.passwords_mismatch': 'Passwörter stimmen nicht überein',
  'auth.rate_limited': 'Zu viele Anfragen. Bitte versuchen Sie es später erneut.',
  'auth.repeat_password': 'Passwort wiederholen',
  'auth.reset_link_valid': 'Der Link ist 1 Stunde gültig.',
  'auth.reset_password_subtitle': 'Geben Sie den Code aus Ihrer E-Mail und ein neues Passwort ein.',
  'auth.reset_password_title': 'Passwort zurücksetzen',
  'auth.reset_sent_message': 'Wenn diese E-Mail existiert, wurde ein Reset-Code gesendet.',
  'auth.reset_sent_subtitle': 'Wir haben einen Link zum Zurücksetzen des Passworts gesendet. Folgen Sie den Anweisungen in der E-Mail.',
  'auth.restore_purchases_heading': 'Käufe wiederherstellen',
  'auth.restore_purchases_subheading': 'Bitte melden Sie sich an, um Ihre Käufe wiederherzustellen.',
  'auth.send_reset': 'Zurücksetzungs-E-Mail senden',
  'auth.service_unavailable': 'Dienst vorübergehend nicht verfügbar. Bitte später erneut versuchen.',
  'auth.show_password': 'Passwort anzeigen',
  'auth.sign_out': 'Abmelden',
  'auth.sign_up': 'Registrieren',
  'auth.sign_up_link': 'Registrieren',
  'auth.signed_in': 'Angemeldet',
  'auth.signin_failed': 'Anmeldung fehlgeschlagen',
  'auth.signup_failed': 'Registrierung fehlgeschlagen',
  'auth.verify': 'Bestätigen',
  'auth.weak_password': 'Das Passwort ist zu schwach.',
  'auth.welcome': 'Willkommen!',
  'auth.welcome_signup': 'Willkommen!',
  'cta.close': 'Schließen',
  'cta.continue': 'Weiter',
  'cta.get_lifetime_access': 'Lebenslangen Zugang erhalten',
  'cta.get_plan_daily': 'Tagesplan erhalten',
  'cta.get_plan_generic': '{interval} Plan erhalten',
  'cta.get_plan_monthly': 'Monatsplan erhalten',
  'cta.get_plan_weekly': 'Wochenplan erhalten',
  'cta.get_plan_yearly': 'Jahresplan erhalten',
  'cta.start_trial': '{days}-tägige kostenlose Testversion starten',
  'modal.close_aria': 'Schließen',
  'modal.continue': 'Weiter',
  'modal.error_generic': 'Etwas ist schiefgelaufen',
  'modal.loading': 'Wird geladen…',
  'modal.purchase_restored_subtitle': 'Alles bereit — viel Spaß!',
  'modal.purchase_restored_title': 'Willkommen zurück',
  'modal.purchase_success_subtitle': 'Alles bereit — viel Spaß!',
  'modal.purchase_success_title': 'Zahlung erhalten',
  'modal.verifying_subscription': 'Abonnement wird geprüft…',
  'nav.back': '← Zurück',
  'nav.back_aria': 'Zurück',
  'offer.limited_time': 'Zeitlich begrenztes Angebot',
  'payment.awaiting_subtitle': 'Wir erkennen Ihre Zahlung automatisch — oder klicken Sie unten, sobald Sie fertig sind.',
  'payment.awaiting_title': 'Zahlung im neuen Tab abschließen',
  'payment.checking': 'Wird geprüft…',
  'payment.ive_paid': 'Ich habe bezahlt',
  'payment.open_checkout_again': 'Checkout erneut öffnen',
  'payment.open_checkout_button': 'Checkout öffnen',
  'payment.popup_blocked_message': 'Ihr Browser hat den Checkout-Tab blockiert. Klicken Sie unten, um ihn zu öffnen.',
  'payment.popup_blocked_title': 'Pop-ups erlauben, um fortzufahren',
  'payment.popup_help_text': 'Hat sich das Checkout-Fenster nicht geöffnet oder wurde es blockiert? Klicken Sie hier, um es erneut zu öffnen.',
  'payment.still_processing': 'Die Zahlung wird noch verarbeitet. Bitte versuchen Sie es gleich erneut.',
  'payment.tab_closed_retry': 'Tab geschlossen? Erneut versuchen',
  'pricing.free_trial_days': '{days}-tägige kostenlose Testversion',
  'pricing.included_per': 'Enthalten pro {interval}:',
  'pricing.interval.day': 'Tag',
  'pricing.interval.lifetime_short': 'lebenslang',
  'pricing.interval.month': 'Monat',
  'pricing.interval.period': 'Zeitraum',
  'pricing.interval.week': 'Woche',
  'pricing.interval.year': 'Jahr',
  'pricing.money_back': '30-Tage-Geld-zurück-Garantie',
  'pricing.most_popular': 'Beliebt',
  'pricing.no_prices': 'Keine Preise verfügbar.',
  'pricing.plan_label.daily': 'TÄGLICHER PLAN',
  'pricing.plan_label.lifetime': 'lebenslang',
  'pricing.plan_label.monthly': 'Monatstarif',
  'pricing.plan_label.weekly': 'Wochentarif',
  'pricing.plan_label.yearly': 'Jahrestarif',
  'pricing.plans_aria': 'Pläne',
  'session.contact_support': 'Support kontaktieren',
  'session.restore_purchases': 'Käufe wiederherstellen',
  'session.sign_out': 'Abmelden',
  'session.signed_in_as_prefix': 'Angemeldet als',
  'session.signing_out': 'Abmelden…',
  'support.attachments_aria': 'Anhänge hochladen',
  'support.attachments_label': 'Anhänge',
  'support.close_button': 'Schließen',
  'support.done_button': 'Fertig',
  'support.dropzone_text': 'Bilder hier ablegen oder zum Auswählen klicken',
  'support.email_placeholder': 'E-Mail eingeben',
  'support.file_requirements': 'JPEG/PNG/WebP, bis zu {max} Dateien, ≤ {size} MB pro Datei',
  'support.heading': 'Support',
  'support.instruction': 'Bitte füllen Sie das Formular aus, um eine Support-Anfrage zu senden.',
  'support.invalid_email': 'Ungültige E-Mail',
  'support.invalid_file': 'Nur JPEG/PNG/WebP, ≤ {size} MB pro Datei',
  'support.message_length': '1–5000 Zeichen',
  'support.message_placeholder': 'Nachricht eingeben',
  'support.remove_file_aria': '{filename} entfernen',
  'support.required': 'Pflichtfeld',
  'support.send_another': 'Weitere Anfrage senden',
  'support.send_button': 'Senden',
  'support.sending': 'Senden…',
  'support.sending_as': 'Senden als',
  'support.subject_length': '3–200 Zeichen',
  'support.subject_placeholder': 'Betreff eingeben',
  'support.success_heading': 'Anfrage gesendet',
  'support.success_message_prefix': 'Wir haben Ihre Nachricht erhalten und antworten an',
  'support.too_many_files': 'Bis zu {max} Dateien'
} as const;

export default de;
